/**
 * Оснащение конкретного места
 */
import { Equipment } from './equipment.model';
import { BaseModel } from '@n3/ng-api-base-kit';

export class PlaceEquipment extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public id: number; /*Идентификатор БД*/
    public equipment: Equipment; /**/
    public quantity: number; /*Количество*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.id = json.id || null;
        this.equipment = new Equipment(json.equipment);
        this.quantity = json.quantity || null;
        this._isEmpty = this.isEmpty(this);
    }
}
